import { BaseApi } from './base.api.js';

export class RpoCalculationApi extends BaseApi {
    constructor(client) {
        super(client, '/rpo-calculation');
    }
}
